<template>
  <span>

    <validation-observer ref="simpleRules">
      <b-form>

        <!-- Report Config File -->
        <b-form-group
          :label="$t('Add File')"
          label-for="report_config_file"
        >
          <b-form-file
            id="library_file"
            v-model="library_file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          />
        </b-form-group>

        <b-button
          variant="primary"
          @click="validationForm"
        >Upload</b-button>
      </b-form>
    </validation-observer>

  </span>

</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BFormFile, BButton,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'

export default {
  components: {
    ValidationObserver,
    BFormGroup,
    BForm,
    BFormFile,
    BButton,
  },
  props: {
    libraryId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      library_file: null,
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success && this.library_file) {
          const formData = new FormData()
          formData.append('LibraryId', this.libraryId)
          formData.append('LibraryFile', this.library_file)

          useJwt.axiosIns.post('library/UploadFiles', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(response => {
              if (response.data) {
                this.$emit('submit', response.data)
                this.library_file = null
              }
            })
            .catch(e => {
              console.log(e)
            })
        } else {
          this.$emit('error', 'Select a file!')
        }
      })
    },
  },
}
</script>
